import { createFileRoute, Outlet } from '@tanstack/react-router';

// RUF-550: viewing/managing one's own asset submissions is portfolio
// self-service, not transactional — no completeness gate.
export const Route = createFileRoute('/submissions')({
  component: () => <Outlet />,
});
